import { gql } from "@apollo/client";

const RAISE_DEDUCTION_DISPUTE = gql`
  mutation RaiseDeductionDispute($params: DisputeRequestInputParams!) {
    disputeRequest(params: $params) {
      id
      deductionId
      processId
    }
  }
`;

export default RAISE_DEDUCTION_DISPUTE;
